export default __webpack_public_path__ + "static/media/download.492bcfa8.svg";